import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as VatugIcon } from "../Asset/Layer_1.svg";
import { ReactComponent as Logo } from "../Asset/footerlogo.svg";
import { ReactComponent as WhiteArror } from "../Asset/greaterwhite.svg";
import { FaRegEnvelope } from "react-icons/fa6";

import "./Footer.css";

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  return (
    <div className="footer-container">
      <div className="footer">
        <div className="foot">
          <div className="newsletter">
            <div className="logo">
              <Logo />
              <p onClick={() => navigate("/")}>
                <VatugIcon />
              </p>
            </div>
            <p>Subscribe to our news letters</p>
              <span>
              <FaRegEnvelope className="logo" />
              <input type="email" placeholder="Enter email" />
             <span>
              <WhiteArror/>
             </span>
              </span>
          </div>
          <div className="link">
            <Link to="/about_us">About Us</Link>
            <Link to="/eagle">Our Edge</Link>
            <Link to="/explore">Explore Features</Link>
            <Link to="/news">News</Link>
            <Link to="/privacy_policy">Privacy Policy</Link>
            <Link to="/terms_conditions">Terms & Conditions</Link>
            <Link to="/contact_us">Contact Us</Link>
          </div>
        </div>
        <div className="right">
          <p>&copy; {currentYear} Company. All rights reserved.</p>
          <a href="https://arveety.com/" target="_blank" rel="noreferrer">
            Designed by Arveety Limited
          </a>
          <div className="icons">
            <i className="fa-brands fa-facebook"></i>
            <i className="fa-brands fa-linkedin"></i>
            <i className="fa-brands fa-youtube"></i>
            <i className="fa-brands fa-instagram"></i>
            <i className="fa-brands fa-twitter"></i>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
